export const container = `bg-ll-surface px-5 py-4 flex w-full items-center gap-x-4 rounded-xl`;

export const iconContainer = `rounded-full bg-ll-primary w-16 h-16 flex items-center justify-center`;
export const iconContent = `rounded-full bg-ll-surface w-12 h-12 border-2 border-white flex items-center justify-center`;
export const icon = `text-ll-primary w-7 h-7`;

export const highlightText = `text-md mb-1`;
export const highlightPill = `text-sm leading-4 font-bold bg-ll-primary text-white py-1 px-2 inline rounded`;
